/**
 * Returns true when `urlValue` looks like a stale URL snapshot relative to what
 * the user is currently showing in the input (debounced `router.replace` lag).
 */
export const isUrlOutOfSyncWithInput = (urlValue: string, inputValue: string) => {
  if (urlValue === inputValue) {
    return false;
  }

  // Require a non-empty URL prefix — every string startsWith(""), so urlValue=""
  // would otherwise block sync after external navigation clears ?q=.
  const isUrlLaggingBehindInput =
    urlValue.length > 0 && urlValue.length < inputValue.length && inputValue.startsWith(urlValue);

  const isUrlNotYetUpdatedAfterInput = urlValue.length > inputValue.length && urlValue.startsWith(inputValue);

  return isUrlLaggingBehindInput || isUrlNotYetUpdatedAfterInput;
};
